import { usePaystackPayment,  } from 'react-paystack';
import { closeBudPayPaymentModal, useBudPayPayment } from "budpay-react-v2";
import { useFlutterwave } from 'flutterwave-react-v3';

import EnvConfig from "../config/env.config";
import { PaymentClient } from '../types/transaction';


const paymentClientsConfig = {
  [PaymentClient.PmtClientBudpay]: {
    api_key: EnvConfig.budpayPublicKey,
    currency: "NGN",
    callback: (res: any) => {
      closeBudPayPaymentModal();
      // toast({
      //   status: "success",
      //   description: "Transaction successful with BudPay",
      // });
    },
    onClose: (res: any) => {
      closeBudPayPaymentModal();
      // toast({
      //   status: "error",
      //   description: "Transaction was not completed, window closed.",
      // });
    },
    usePaymentHook: useBudPayPayment,
  },
  [PaymentClient.PmtClientFlutterwave]: {
    public_key: EnvConfig.flutterwavePublicKey,
    currency: "NGN",
    // callback: (res: any) => {
    //   closeFlutterwaveModal();
    //   // Handle Flutterwave callback
    // },
    // onClose: (res: any) => {
    //   // Handle Flutterwave close
    // },
    usePaymentHook: useFlutterwave, // Assume you have a hook for Flutterwave
  },
  [PaymentClient.PmtClientPaystack]: {
    publicKey: EnvConfig.paystackPublicKey,
    currency: "NGN",
    // callback: (res: any) => {
    //   // Handle Paystack callback
    // },
    // onClose: (res: any) => {
    //   // Handle Paystack close
    // },
    usePaymentHook: usePaystackPayment, // Assume you have a hook for Paystack
  },
};

export const activePaymentClient = PaymentClient.PmtClientPaystack;
export const activePaymentConfig = paymentClientsConfig[activePaymentClient];
